import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const chatSocket = io(`${SOCKET_URL}/chat`, {
  withCredentials: true,
  autoConnect: false,
  transports: ['websocket', 'polling'],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  timeout: 20000,
});

chatSocket.on('connect', () => {
  console.log('[ChatSocket] Connected:', chatSocket.id);
});

chatSocket.on('connect_error', (err) => {
  console.error('[ChatSocket] Connection error:', err.message);
});

chatSocket.on('disconnect', (reason) => {
  console.log('[ChatSocket] Disconnected:', reason);
});

export default chatSocket;